import WhatsappLink from "../../../utils/WhatsappLink";
import "./meet.css";
import { FaArrowRight } from "react-icons/fa";

export const Meet = ({ showImage = true }) => {
  return (
    <section className="meet-wrapper" style={{ marginBottom: "4rem" }}>
      <div className="meet-box">
        <p className="meet-title">
          ¿Cómo combinar eficazmente la inteligencia <br /> de negocios y del
          cliente?
        </p>
        <WhatsappLink>
          <button className="boton-generico boton-gris">
            <p>Más info</p>
            <FaArrowRight />
          </button>
        </WhatsappLink>
      </div>
      {showImage && (
        <img
          alt="idea"
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/img_avataridea.png`}
          className="bi-image"
        />
      )}
    </section>
  );
};
